import React from 'react';
import { Box, Divider, IconButton, InputLabel, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import {
  AccountCircle,
  ChevronLeft,
  ChevronRight,
  DirectionsCar,
  ExitToApp,
} from '@material-ui/icons';
import { injectIntl } from 'react-intl';

import docCookies from '../../../docCookies';
import { history } from '../../../history';
import styles from '../styles';
import messages from './messages';
import useGlobalContext from '../../../common/hooks/useGlobalContext';
import RidecellLogo from '../../../common/assets/ridecellLogo.jpeg';
import RidecellLogoSmall from '../../../common/assets/ridecellLogoSmall.png';
import BusinessDropdown from '../../../common/elements/BusinessDropdown';
import ServiceDropdown from '../../../common/elements/ServiceDropdown';

export const LeftMenu = (props) => {
  const {
    classes,
    intl: { formatMessage },
    isCarsharing,
    open,
    toggleDrawer,
  } = props;
  const {
    state: { activeBusinessId, activeServiceId, tabState, associatedBusinesses, tenantSettings },
    setActiveBusinessId,
    setActiveServiceId,
    setTabState,
  } = useGlobalContext();

  const logout = () => {
    docCookies.removeItem('jwt');
    docCookies.removeItem('username');
    docCookies.removeItem('user_id');
    history.push('/login');
  };
  const activeBusiness = associatedBusinesses.find((business) => business.id === activeBusinessId);
  let brandLogoLg = RidecellLogo; // !!activeBusiness.brand_logo ? activeBusiness.brand_logo : RidecellLogo
  let brandLogoSm = RidecellLogoSmall; // !!activeBusiness.brand_logo ? activeBusiness.brand_logo : RidecellLogoSmall

  if (activeBusiness && !!activeBusiness.brand_logo) {
    brandLogoLg = activeBusiness.brand_logo;
    brandLogoSm = activeBusiness.brand_logo;
  } else if (tenantSettings.agency_logo !== '/static/common/images/agency_logo.png') {
    brandLogoLg = tenantSettings.agency_logo;
    brandLogoSm = tenantSettings.agency_logo;
  }

  return (
    <React.Fragment>
      <Box className={clsx(classes.flex, classes.toolbar)}>
        <IconButton onClick={toggleDrawer}>{open ? <ChevronLeft /> : <ChevronRight />}</IconButton>
        <Box mt={2}>
          <img
            alt="logo"
            height={45}
            className={clsx({ [classes.none]: !open })}
            src={brandLogoLg}
          />
          <img
            alt="logo"
            height={45}
            className={clsx({ [classes.none]: open })}
            src={brandLogoSm}
          />
        </Box>
        <Box className={clsx(classes.flex, classes.leftMenuIcons)}>
          {!isCarsharing && (
            <>
              <IconButton
                color={tabState === 'create' ? 'primary' : 'inherit'}
                onClick={() => setTabState('create')}
              >
                <DirectionsCar />
              </IconButton>
              <Typography color={tabState === 'create' ? 'primary' : 'inherit'} variant="caption">
                {formatMessage(messages.create)}
              </Typography>
            </>
          )}
          <br />
          <IconButton
            color={tabState === 'profile' ? 'primary' : 'inherit'}
            onClick={() => setTabState('profile')}
          >
            <AccountCircle />
          </IconButton>
          <Typography color={tabState === 'profile' ? 'primary' : 'inherit'} variant="caption">
            {formatMessage(messages.profile)}
          </Typography>
        </Box>
      </Box>
      {open && (
        <Box>
          <Box pt={2} pb={2}>
            <Divider />
          </Box>
          {activeBusinessId && (
            <Box p={2}>
              <InputLabel>{formatMessage(messages.business)}</InputLabel>
              <BusinessDropdown
                onChange={(e) => setActiveBusinessId(e.target.value)}
                value={activeBusinessId}
              />
            </Box>
          )}
          {!isCarsharing && activeServiceId && (
            <Box p={2}>
              <ServiceDropdown
                hasTitle
                onChange={(e) => setActiveServiceId(e.target.value)}
                value={activeServiceId}
              />
            </Box>
          )}
        </Box>
      )}
      <Box className={clsx(classes.flex, classes.toolbar, classes.bottomIcons)}>
        <Box className={clsx(classes.flex, classes.leftMenuIcons)}>
          <IconButton onClick={logout}>
            <ExitToApp />
          </IconButton>
          <Typography variant="caption">{formatMessage(messages.logout)}</Typography>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default withStyles(styles)(injectIntl(LeftMenu));
